// Section 12: Injury. From job risk; 2 seasons untreated, 1 treated; death 2% per season
// untreated; strength -30 while injured; not contagious. Constants: config.illnesses.injury.
import type { Config } from '../../config';
import { mod } from '../../core/modifiers';
import { noDeltas } from '../../core/content-helpers';
import { defineIllness } from '../../core/registry';

export function injury(config: Config) {
  const c = config.illnesses.injury;

  return defineIllness({
    id: 'injury',
    label: 'Injury',
    section: 'S12',
    source: 'job',
    weight: c.weight,
    untreatedSeasons: c.untreated,
    treatedSeasons: c.treated,
    deathChance: c.death,
    contagious: false,
    modifierTargets: ['strengthChange'],
    modifiers(ctx, target) {
      if (target.kind !== 'strengthChange') return [];
      const p = ctx.state.people[target.personId];
      return p !== undefined && p.status.injured !== null
        ? [mod.add('illness:injury', -c.strengthPenalty, 'injured')]
        : [];
    },
    onCatch: (ctx, person) => [
      { kind: 'memory', personId: person.id, entry: { turn: ctx.season.turn, kind: 'injured' } },
    ],
    onRecover: noDeltas,
  });
}
